<!-- <a [routerLink]="['/counter']">Counter</a> -->
<router-outlet></router-outlet>


// WEBPACK FOOTER //
// ./src/app/app.component.html